import { getHeaderNavLinks } from './navLinks';
var nav = ['Ana Sayfa', 'Çalışma Araçları', 'Soru Sor', 'Matematik Problemlerini Çöz', 'Yazı Merkezini Ziyaret Et'];
var secondaryNav = ['Kariyer'];
var userNav = ['Hesabım', 'Matematik', 'Yazı', 'Yardım', 'Çıkış Yap'];
var lifePrimaryNav = ['Para', 'Sağlık + Wellness', 'Yaşam Becerileri', 'Kaynaklar', 'Hakkımızda', 'Chegg Life Ara', 'Yardım Al'];
var qnaNav = ['Şimdi Katıl', 'Yeniden Abone Ol', 'Devam Et'];
var qnaUserNav = ['Hesabım', 'Matematik', 'Yazı', 'Yardım', 'Çıkış Yap'];
export default getHeaderNavLinks(nav, secondaryNav, userNav, lifePrimaryNav, qnaNav, qnaUserNav);